/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import _ from 'lodash'
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import AuthLogConfigApi, { AuthLogConfigDOI } from '../api/authLogConfigApi'
import AuthLogConfig from '../authLogConfig';
import EnumStationType from 'src/enums/enumStationType';
import { Toast } from 'src/util/toast';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import EnumAuthStatus from 'src/enums/enumAuthStatus';

export default class AuthLogConfigService extends ListPageService {
    ctx: AuthLogConfig;
    
    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

    constructor (ctx: AuthLogConfig) {
        super()
        this.ctx = ctx
    }

    @override
    createColumns (): ColDefCustom [] {
        let t = this
        return [
            {
                headerName: '序列号',
                field: 'mn',
                minWidth: 160,
            },
            {
               headerName: 'SIMID',
               field: 'sim',
               minWidth: 160,
            },
            {
                headerName: '授权时间',
                field: 'datetime',
                minWidth: 160,
            },
            {
                headerName: '文件名称',
                field: 'file_name',
                minWidth: 160,
            },
            {
                headerName: '授权状态',
                field: 'is_auth',
                minWidth: 100,
                maxWidth:100,
                cellRenderer(params) {
                    let data: AuthLogConfigDOI.RowDataI = params.data;
                    return EnumAuthStatus.findId(data.is_auth).getName();
                },
            },
        ]
   }

    @override
   createBtnGroup(): Array<IconBtnItem> {
       let t = this;
       return [
       ];
   }


    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [];
    }


    @override
    initSearchParams (): void {
        this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<AuthLogConfigDOI.QueryRowDataParamsI>(),
            page_index: this.ctx.currentPage,
            page_size: this.ctx.pageSize,
        }
        this.ctx.currentPage = 1
    }

    @override
    async searchTable () {
        let ctx = this.ctx
        let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
        ag.showLoading()
        let {code, data} = await AuthLogConfigApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage
        })
        ag.hideLoading()

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count
        }
    }

}
